<script setup lang="ts">
import AppButton from "~/components/Common/Buttons/AppButton.vue";
import SvgIcon from "~/components/Common/SvgIcon.vue";
import { useAttendanceReviewStore } from "~/store/attendance/attendance-review.store";
import { attendanceConfirmationLines } from "~/utils/helpers/attendance/confirmation-lines";

const store = useAttendanceReviewStore();

const lines = computed(() => attendanceConfirmationLines(store.confirmation));
</script>

<template>
  <!-- No card of its own: this is the assistant's bubble, which carries the tint and the padding. -->
  <div class="flex flex-col gap-2.5">
    <div class="flex items-center gap-2">
      <!-- The outlined `validate`, not the filled `validate_green`: the design draws a ring here. -->
      <SvgIcon name="validate" class="h-[16px] w-[16px] shrink-0 text-medium-green-color" />
      <span class="body_demi text-primary-color">Émargement confirmé</span>
    </div>

    <div class="flex flex-col">
      <span v-for="line in lines" :key="line" class="body_regular text-secondary-color">{{ line }}</span>
    </div>

    <!-- Full width, arrow trailing: the recap's one action, as the design draws it. -->
    <AppButton
      v-if="store.confirmation?.sessionId"
      class="w-full"
      label="Voir la session"
      icon="arrow_right"
      reverse-icon
      @click="store.viewSession()"
    />
  </div>
</template>
